"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewaySelector = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var GatewaySelector = function (_a) {
    var gateways = _a.gateways, onChange = _a.onChange, value = _a.value, hideNone = _a.hideNone;
    var internalValue = value == null ? "None" : value;
    return (react_1.default.createElement(kaleidoscope_1.Select, { autoStack: true, isNestedPortal: true, placeholder: "Select a Gateway", label: "Payment gateway", labelHidden: hideNone, value: internalValue, onChange: onChange, disabled: gateways.length == 0 },
        !hideNone && react_1.default.createElement(kaleidoscope_1.SelectOption, { value: "None" }, "None"),
        gateways.map(function (gateway) { return (react_1.default.createElement(kaleidoscope_1.SelectOption, { key: gateway.id, value: gateway.id }, gateway.name)); })));
};
exports.GatewaySelector = GatewaySelector;
